// Use window.env only in production (when not on localhost)
const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

const env = isLocalhost
  ? (import.meta.env as Record<string, string>)
  : ({ ...import.meta.env, ...window.env } as Record<string, string>);

const Config = {
  API_HOST: env.VITE_APP_API_HOST,
  API_HOST_V3: env.VITE_APP_API_HOST_V3,
  API_HOST_PUBLIC: env.VITE_APP_API_HOST_PUBLIC,
  CLASSIC: env.VITE_APP_CLASSIC,
  API_CMS: env.VITE_APP_API_CMS,
  API_AMS: env.VITE_APP_API_AMS,
  WEBSOCKET_HOST: env.VITE_APP_WEBSOCKET_HOST,
  DEFAULT_SOCCER_TAG_ID: env.VITE_APP_DEFAULT_SOCCER_TAG_ID,
  RELEASE_VERSION: env.VITE_APP_VERSION,
  CSS_THEME: env.VITE_APP_CSS_THEME,
  SENTRY: env.VITE_APP_SENTRY,
  DOMAIN: env.VITE_APP_DOMAIN,
  PUBLIC_DOMAIN: env.VITE_APP_PUBLIC_DOMAIN,
  MAIN_SITE_URL: env.VITE_APP_MAIN_SITE_URL,
  SPEED_URL: env.VITE_APP_SPEED_URL,
  BUILD_HASH: "{{POST_BUILD_ENTERS_HASH_HERE}}", // post build script replaces this string with the hash from main.js
  PUBLIC_VIEW: env.VITE_APP_PUBLIC_VIEW,
  PRODUCTION: env.VITE_APP_PRODUCTION,
};
export default Config;
